import { Link } from "@postenbring/hedwig-react";
import { ArrowUpRightIcon } from "../../shared/icons";

const TrustPilot = ({ site }) => (
    <div
        id="trustpilot-anchor"
        className="trustpilot-widget"
        data-locale={site === "bringdk" ? "da-DK" : "sv-SE"}
        data-template-id="5419b732fbfb950b10de65e5"
        data-businessunit-id={
            site === "bringdk" ? "4bc6d2420000640005055443" : "4e38879e000064000510a266"
        }
        data-style-height="24px"
        data-style-width="100%"
        data-theme="dark"
        style={{ colorScheme: "normal" }}
    >
        <Link
            href={
                site === "bringdk"
                    ? "https://dk.trustpilot.com/review/www.bring.dk"
                    : "https://se.trustpilot.com/review/www.bring.se"
            }
            target="_blank"
            rel="noopener noreferrer"
            icon="trailing"
        >
            Trustpilot
            <ArrowUpRightIcon />
        </Link>
    </div>
);

export default TrustPilot;
